import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=6f3e7a2b&scoped=true"
import script from "./ScrollView.vue?vue&type=script&lang=ts"
export * from "./ScrollView.vue?vue&type=script&lang=ts"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=6f3e7a2b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e7a2b",
  null
  
)

export default component.exports